"use client";

import React from "react";
import { MapPin, Activity, ArrowRight, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PersonalPage() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const interests = ["Urban Photography", "Strategic Gaming", "Economic Theory", "Data-Driven Solutions", "Corporate Strategy", "Entrepreneurial Innovation", "Case Study Analysis"];
  return <section id="personal-page" className="relative w-full bg-background overflow-hidden py-20 lg:py-32 min-h-[90vh] flex items-center">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.03] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600191/img/chicago_topo_watermark.png)] bg-cover bg-center bg-no-repeat pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6 w-fit">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              Loyola University Chicago
            </div>
            
            <h1 className="font-serif text-5xl md:text-6xl lg:text-[4.5rem] font-bold text-foreground mb-6 leading-[1.1] tracking-tight"><br />Nathan Harrington<br /></h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl leading-relaxed">I am a graduate student at Loyola University Chicago’s School of Business, pursuing a Master’s degree with a focus in Finance.&nbsp;</p>
            
            <div className="flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="rounded-full px-8">
                <Link href="/contact">
                  Connect with Nathan <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 bg-background/50 backdrop-blur-sm">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 h-full transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="grid grid-cols-2 grid-rows-[auto_auto] gap-4 h-full max-w-md mx-auto lg:max-w-none !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/8CC37BA4-3AE4-4CDC-AC2F-B8840AB5FEC2_1_105_c-1.jpeg)] !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/7C44A643-EC21-42AB-A266-048F54A64A18_1_105_c.jpeg)] !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/7C44A643-EC21-42AB-A266-048F54A64A18_1_105_c.jpeg)] !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/7C44A643-EC21-42AB-A266-048F54A64A18_1_105_c.jpeg)] !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/7C44A643-EC21-42AB-A266-048F54A64A18_1_105_c.jpeg)] !bg-[url(https://up-drum.10web.cloud/wp-content/uploads/2026/03/7C44A643-EC21-42AB-A266-048F54A64A18_1_105_c-1.jpeg)]">
              
              {}
              

              {}
              

              {}
              

            </div>
          </div>

        </div>
      </div>
    </section>;
}